// extracted by mini-css-extract-plugin
module.exports = {"root":"_6190b0","paper":"_8c4820","title":"_eb7636","closeIcon":"_29c639"};